import { render, staticRenderFns } from "./approvalFormsView.vue?vue&type=template&id=e39abce2&scoped=true"
import script from "./approvalFormsView.vue?vue&type=script&lang=js"
export * from "./approvalFormsView.vue?vue&type=script&lang=js"
import style0 from "./approvalFormsView.vue?vue&type=style&index=0&id=e39abce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39abce2",
  null
  
)

export default component.exports